import styled from 'styled-components';
import { convertDigitToProperFormat } from '../../utils/number';
import { green } from '../../utils/style/colors';
import Icon from '../Icon/Icon';

const getProgressColor = (progress: number) => {
  if (progress < 50) {
    return `rgb(255, ${Math.floor(progress * 5.1)}, 0)`;
  } else if (progress < 90) {
    return `rgb(${Math.floor(255 - (progress - 50) * 5.1)}, 255, 8)`;
  } else return `rgb(${Math.floor(progress / 4)}, 255, 8)`;
};

const Wrapper = styled.div`
  position: relative;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  display: flex;
  align-items: center;
  padding: 3px;
  justify-content: center;
`;

const ProgressCircle = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 10px;
  background: ${({ progress }) =>
    progress === 0
      ? '#e5e5e5'
      : `conic-gradient(
          ${getProgressColor(progress)} ${progress}%,
          #e5e5e5 ${progress}%
        )`};

  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.6s ease;
`;

const Percentage = styled.span`
  position: absolute;
  font-size: 0.75rem;
  font-weight: 600;
  color: #333;
`;

const CheckMark = styled.div`
  position: absolute;
  top: 3px;
  font-size: ${(props) => props.size * 0.65}px;
  font-weight: bold;
  color: ${green};
  animation: pop 0.5s ease-out;

  @keyframes pop {
    0% {
      transform: scale(0.5);
      opacity: 0;
    }
    50% {
      transform: scale(1.3);
      opacity: 1;
    }
    100% {
      transform: scale(1);
    }
  }
`;

const SquereProgress = ({
  progress = 0,
  size = 30,
  isProgressive = true,
  showOnlyPercent = false,
}) => {
  const clampedProgress = Math.min(100, Math.max(0, progress));

  const getProgressIcon = (val: number) => {
    if (val === 100) return 'check-circle';
    if (val === 0) return 'circle';
    if (val === -1) return 'x-circle';
    return 'activity';
  };

  return (
    <Wrapper size={size}>
      {isProgressive ? (
        <>
          <ProgressCircle progress={clampedProgress}>
            {!showOnlyPercent && clampedProgress === 100 && (
              <CheckMark size={size}>
                <Icon type={'check'} color={'black'} />
              </CheckMark>
            )}
          </ProgressCircle>
          <Percentage>
            {(showOnlyPercent || clampedProgress !== 100) &&
              convertDigitToProperFormat(clampedProgress?.toString()) + '%'}
          </Percentage>{' '}
        </>
      ) : (
        <Icon type={getProgressIcon(progress)} />
      )}
    </Wrapper>
  );
};

export default SquereProgress;
